import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { InvoicingReportFilterModel } from 'src/app/models/invoicing/invoicing-report-filter.model';
import { RentalReportFilterModel } from 'src/app/models/rental/rental-report-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoicingReportService {

  constructor(private _httpClient: HttpClient) { }

  exportInvoicingReportDiscountsLowerHundredPercent(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportDiscountsLowerHundredPercent}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportDiscountsTopThirtyPercent(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportDiscountsTopThirtyPercent}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportIncomeCostcenterEquipment(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportIncomeCostcenterEquipment}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportIncomeReport(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportIncomeReport}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicesByConcept(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicesByConcept}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingAddressReport(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingAddressReport}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicesGenerated(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicesGenerated}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingBusinessType(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingBusinessType}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingClient(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingClient}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingClientConstructionSiteCostCenter(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingClientConstructionSiteCostCenter}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingClientCostCenterGroup(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingClientCostCenterGroup}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingConcept(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingConcept}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingConceptSeller(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingConceptSeller}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingCostCenter(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingCostCenter}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingFamily(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingFamily}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingSellerConcept(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingSellerConcept}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingSellerKilograms(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingSellerKilograms}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportItemRevenue(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportItemRevenue}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportDailyReportVoucher(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportDailyReportVoucher}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportInvoicingKilograms(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportInvoicingKilograms}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportPreInvoicingItemRevenue(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportPreInvoicingItemRevenue}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportItemRevenueStore(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportItemRevenueStore}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportPendingInvoice(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportPendingInvoice}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportTaxReport(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportTaxReport}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportTotalMonth(invoicingReportFilter: InvoicingReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportTotalMonth}`, invoicingReportFilter, {
      responseType: 'blob',
    });
  }

  exportInvoicingReportBalancesCostCenter(rentalReportFilterModel: RentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ExportInvoicingReportBalancesCostcenter}`, rentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  getDiscountsLowerHundredPercent(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.DiscountsLowerHundredPercent}`, invoicingReportFilter);
  }

  getDiscountsTopThirtyPercent(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.DiscountsTopThirtyPercent}`, invoicingReportFilter);
  }

  getInvoicesByConcept(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicesByConcept}`, invoicingReportFilter);
  }

  getInvoicingAddressReport(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingAddressReport}`, invoicingReportFilter);
  }

  getInvoicesGenerated(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicesGenerated}`, invoicingReportFilter);
  }

  getInvoicingClient(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingClient}`, invoicingReportFilter);
  }

  getInvoicingClientConstructionSiteCostCenter(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingClientConstructionSiteCostCenter}`, invoicingReportFilter);
  }

  getInvoicingClientCostCenterGroup(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingClientCostCenterGroup}`, invoicingReportFilter);
  }

  getIncomeReport(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.IncomeReport}`, invoicingReportFilter);
  }

  getIncomeCostcenterEquipment(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.IncomeCostcenterEquipment}`, invoicingReportFilter);
  }

  getInvoicingBusinessType(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingBusinessType}`, invoicingReportFilter);
  }

  getInvoicingConcept(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingConcept}`, invoicingReportFilter);
  }

  getInvoicingConceptSeller(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingConceptSeller}`, invoicingReportFilter);
  }

  getInvoicingCostCenter(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingCostCenter}`, invoicingReportFilter);
  }

  getInvoicingFamily(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingFamily}`, invoicingReportFilter);
  }

  getInvoicingReportDailyReportVoucher(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingReportDailyReportVoucher}`, invoicingReportFilter);
  }

  getInvoicingKilograms(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingKilograms}`, invoicingReportFilter);
  }

  getInvoicingSellerConcept(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingSellerConcept}`, invoicingReportFilter);
  }

  getInvoicingSellerKilograms(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingSellerKilograms}`, invoicingReportFilter);
  }

  getItemRevenue(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ItemRevenue}`, invoicingReportFilter);
  }

  getPreInvoicingItemRevenue(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.PreInvoicingItemRevenue}`, invoicingReportFilter);
  }

  getItemRevenueStore(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.ItemRevenueStore}`, invoicingReportFilter);
  }

  getPendingInvoice(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.PendingInvoice}`, invoicingReportFilter);
  }

  getTaxReport(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.TaxReport}`, invoicingReportFilter);
  }

  getTotalMonth(invoicingReportFilter: InvoicingReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.TotalMonth}`, invoicingReportFilter);
  }

  invoicingBalancesCostcenter(rentalReportFilterModel: RentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoicingReport.InvoicingBalancesCostcenter}`,
      rentalReportFilterModel);
  }
}
